var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-alert',{attrs:{"data-testid":"anchor-index-n69fib","closable":false,"title":_vm.$t('module_creative_edit_anchor_alert'),"data-tea-expose":"creative_update_to_anchor_banner_impression","type":"warning","show-icon":""}})}
var staticRenderFns = []

export { render, staticRenderFns }